export default __webpack_public_path__ + "static/media/cfdImg.b8182fd4.webp";